var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "inspection-preview-toolbar" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-sm btn-primary",
          attrs: { type: "button" },
          on: { click: _vm.toggleServicePreview },
        },
        [_vm._v("\n      " + _vm._s(_vm.previewButtonLabel) + "\n    ")]
      ),
      _vm._v(" "),
      _vm.previewError
        ? _c("span", { staticClass: "ml-2 text-danger" }, [
            _vm._v(_vm._s(_vm.previewError)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.previewLoading
        ? _c("span", { staticClass: "ml-2 text-muted" }, [
            _vm._v("Chargement des correspondances..."),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "table table-bordered w-100" }, [
      _c("thead", [
        _c("tr", [
          _c("th", { staticStyle: { width: "250px" } }, [
            _vm._v("Description"),
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "bg-green-jungle" }, [_vm._v(" ")]),
          _vm._v(" "),
          _c("th", { staticClass: "bg-yellow-lemon" }, [_vm._v(" ")]),
          _vm._v(" "),
          _c("th", { staticClass: "bg-red" }, [_vm._v(" ")]),
          _vm._v(" "),
          _c("th", [_vm._v("Commentaire*")]),
          _vm._v(" "),
          _c(
            "th",
            { style: { width: _vm.columnWidth, maxWidth: _vm.columnWidth } },
            [
              _vm.previewVisible
                ? [_vm._v("Service proposé")]
                : _c(
                    "label",
                    {
                      staticClass: "mb-0",
                      staticStyle: { cursor: "pointer" },
                      attrs: { title: "Tout cocher / tout décocher" },
                    },
                    [
                      _c("input", {
                        staticClass: "auto-service-master",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.allAutoServiceChecked,
                          indeterminate:
                            _vm.someAutoServiceChecked &&
                            !_vm.allAutoServiceChecked,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.toggleAutoServiceAll(
                              $event.target.checked
                            )
                          },
                        },
                      }),
                      _vm._v("\n            Auto-service\n          "),
                    ]
                  ),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(
          _vm.inspectionData.verifications,
          function (verification, index) {
            return _c("tr", { key: index }, [
              _c("td", { staticStyle: { padding: "8px" } }, [
                _c("input", {
                  attrs: {
                    type: "hidden",
                    name: `invoice_inspection_verification_id[${_vm.invoiceInspectionId}][${index}]`,
                  },
                  domProps: {
                    value: verification.invoice_inspection_verification_id,
                  },
                }),
                _vm._v(" "),
                verification.invoice_inspection_verification_checked_box == null
                  ? _c("input", {
                      attrs: {
                        type: "hidden",
                        name: `invoice_inspection_verification_checked_box[${_vm.invoiceInspectionId}][${index}]`,
                        value: "0",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    type: "hidden",
                    name: `invoice_inspection_verification_label[${_vm.invoiceInspectionId}][${index}]`,
                  },
                  domProps: {
                    value:
                      verification.invoice_inspection_verification_label || "",
                  },
                }),
                _vm._v(
                  "\n          " +
                    _vm._s(verification.invoice_inspection_verification_label) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "bg-green-jungle",
                  class: {
                    checked:
                      verification.invoice_inspection_verification_checked_box ==
                      "1",
                  },
                  staticStyle: {
                    width: "50px",
                    "vertical-align": "middle",
                    "text-align": "center",
                  },
                  on: {
                    click: function ($event) {
                      verification.invoice_inspection_verification_checked_box =
                        verification.invoice_inspection_verification_checked_box ==
                        1
                          ? 0
                          : 1
                    },
                  },
                },
                [
                  _c("input", {
                    attrs: {
                      type: "checkbox",
                      name: `invoice_inspection_verification_checked_box[${_vm.invoiceInspectionId}][${index}]`,
                      value: "1",
                    },
                    domProps: {
                      checked:
                        verification.invoice_inspection_verification_checked_box ==
                        "1",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "bg-yellow-lemon",
                  class: {
                    checked:
                      verification.invoice_inspection_verification_checked_box ==
                      "2",
                  },
                  staticStyle: {
                    width: "50px",
                    "vertical-align": "middle",
                    "text-align": "center",
                  },
                  on: {
                    click: function ($event) {
                      verification.invoice_inspection_verification_checked_box =
                        verification.invoice_inspection_verification_checked_box ==
                        2
                          ? 0
                          : 2
                    },
                  },
                },
                [
                  _c("input", {
                    attrs: {
                      type: "checkbox",
                      name: `invoice_inspection_verification_checked_box[${_vm.invoiceInspectionId}][${index}]`,
                      value: "2",
                    },
                    domProps: {
                      checked:
                        verification.invoice_inspection_verification_checked_box ==
                        "2",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "bg-red",
                  class: {
                    checked:
                      verification.invoice_inspection_verification_checked_box ==
                      "3",
                  },
                  staticStyle: {
                    width: "50px",
                    "vertical-align": "middle",
                    "text-align": "center",
                  },
                  on: {
                    click: function ($event) {
                      verification.invoice_inspection_verification_checked_box =
                        verification.invoice_inspection_verification_checked_box ==
                        3
                          ? 0
                          : 3
                    },
                  },
                },
                [
                  _c("input", {
                    attrs: {
                      type: "checkbox",
                      name: `invoice_inspection_verification_checked_box[${_vm.invoiceInspectionId}][${index}]`,
                      value: "3",
                    },
                    domProps: {
                      checked:
                        verification.invoice_inspection_verification_checked_box ==
                        "3",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("td", [
                _c("textarea", {
                  ref: "comment-box",
                  refInFor: true,
                  staticClass: "comment-box",
                  attrs: {
                    required:
                      parseInt(
                        verification.invoice_inspection_verification_checked_box
                      ) > 1,
                    name: `invoice_inspection_verification_comment[${_vm.invoiceInspectionId}][${index}]`,
                  },
                  domProps: {
                    innerHTML: _vm._s(
                      verification.invoice_inspection_verification_comment
                    ),
                  },
                  on: {
                    input: function ($event) {
                      _vm.handleCommentInput(verification)
                      _vm.editInspection()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "td",
                {
                  style: {
                    padding: "8px",
                    width: _vm.columnWidth,
                    maxWidth: _vm.columnWidth,
                    verticalAlign: "middle",
                  },
                },
                [
                  _vm.previewVisible
                    ? _c("div", [
                        _c(
                          "select",
                          {
                            staticClass:
                              "form-control inspection-service-select",
                            attrs: {
                              "data-verification-index": index,
                              name: `invoice_inspection_verification_service_id[${_vm.invoiceInspectionId}][${index}]`,
                            },
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("-- Aucun --"),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.serviceOptions, function (service) {
                              return _c(
                                "option",
                                {
                                  key: service.id,
                                  domProps: { value: service.id },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(service.text) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ])
                    : _c("div", { staticClass: "text-center" }, [
                        _c("input", {
                          attrs: {
                            type: "hidden",
                            name: `invoice_inspection_verification_auto_service[${_vm.invoiceInspectionId}][${index}]`,
                            value: "0",
                          },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: verification.auto_service,
                              expression: "verification.auto_service",
                            },
                          ],
                          staticClass: "auto-service-checkbox",
                          attrs: {
                            type: "checkbox",
                            name: `invoice_inspection_verification_auto_service[${_vm.invoiceInspectionId}][${index}]`,
                            value: "1",
                          },
                          domProps: {
                            checked: Array.isArray(verification.auto_service)
                              ? _vm._i(verification.auto_service, "1") > -1
                              : verification.auto_service,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = verification.auto_service,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "1",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      verification,
                                      "auto_service",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      verification,
                                      "auto_service",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(verification, "auto_service", $$c)
                              }
                            },
                          },
                        }),
                      ]),
                ]
              ),
            ])
          }
        ),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }